/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import logger from '../../utils/logger';
import { useCallback, useMemo, useEffect, useContext, useRef, useState } from 'react';
import {
  useEdgesState,
  useNodesState,
  SmoothStepEdge,
  BezierEdge,
  StraightEdge,
  ReactFlowProvider,
} from '@xyflow/react';
import ProcessMapFlow from './components/ProcessMapFlow';
import '@xyflow/react/dist/style.css';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Popup from '../../components/Popup';
import CustomAlert from '../../components/CustomAlert';
import ArrowBoxNode from '../../all-node/process-map-nodes/ArrowBoxNode';
import PentagonNode from '../../all-node/process-map-nodes/PentagonNode';
import { getLevelKey } from '../../utils/getLevel';
import apiExports, { moveNode, checkParentPublishRecords } from '../../api/api';
import { BreadcrumbsContext } from '../../context/BreadcrumbsContext';
import CustomContextMenu from '../../components/CustomContextMenu';
import { useSelector } from 'react-redux';
import '../../css/MapLevel.css';
import StickyNote from '../../all-node/process-map-nodes/StickyNote';
import { useDynamicHeight } from '../../hooks/useDynamicHeight';
import useCheckFavorite from '../../hooks/useCheckFavorite';
import { usePageGroupIdViewer } from '../../hooks/usePageGroupIdViewer';
import { useLangMap } from '../../hooks/useLangMap';
import { useFetchVersions } from '../../hooks/useFetchVersions';
import { useFetchNodes } from '../../hooks/useFetchNodes';
import { useLabelChange } from '../../hooks/useLabelChange';
import { useProcessNavigation } from '../../hooks/useProcessNavigation';
import { buildProcessPath } from '../../routes/buildProcessPath';
import { useApprovalStatus } from '../../hooks/useApprovalStatus';
import { useTranslation } from '../../hooks/useTranslation';
import useEnergyMeter from '../../hooks/useEnergyMeter';
// Custom Components and Hooks
import MapLevelModals from './components/MapLevelModals';
import { useMapLevelState } from './hooks/useMapLevelState';
import { useMapLevelHandlers } from './hooks/useMapLevelHandlers';
import { useMapLevelViewHandlers } from './hooks/useMapLevelViewHandlers';
import { useMapLevelVersionData } from './hooks/useMapLevelVersionData';
import { useMapLevelApprovals } from './hooks/useMapLevelApprovals';
import { useReconstructBreadcrumbs } from '../../hooks/useReconstructBreadcrumbs';

const MapLevel = () => {
  const state = useMapLevelState();
  const {
    // selectedNodeId, setSelectedNodeId,
    checkpublish,
    Setcheckpublish,
    showPublishPopup,
    setShowPublishPopup,
    showEditorialPopup,
    setShowEditorialPopup,
    showContentPopup,
    setShowContentPopup,
    showTranslationPopup,
    setShowTranslationPopup,
    showVersionPopup,
    setShowVersionPopup,
    showContextMenu,
    setShowContextMenu,
    showPopup,
    setShowPopup,
    selectedNode,
    setSelectedNode,
    popupTitle,
    setPopupTitle,
    checkRecord,
    setcheckRecord,
    getPublishedDate,
    setgetPublishedDate,
    getDraftedDate,
    setDraftedDate,
    process_img,
    setprocess_img,
    processDefaultlanguage_id,
    setprocessDefaultlanguage_id,
    OriginalDefaultlanguge_id,
    setOriginalDefaultlanguge_id,
    versionPopupPayload,
    setversionPopupPayload,
    ParentPageGroupId,
    SetParentPageGroupId,
    title,
    Settitle,
    TitleTranslation,
    SetTitleTranslation,
    isFavorite,
    setIsFavorite,
    isNavigating,
    setIsNavigating,
    supportedLanguages,
    setSupportedLanguages,
    user,
    setUser,
    contextMenuPosition,
    setContextMenuPosition,
    OriginalPosition,
    setOriginalPosition,
    popupPosition,
    setPopupPosition,
    translationDefaults,
    setTranslationDefaults,
    hasUnsavedChanges,
    setHasUnsavedChanges,
  } = state;

  const { remainingHeight } = useDynamicHeight();
  const safeRemainingHeight = Math.min(Math.max(remainingHeight, 350), 588);
  const {
    mode,
    version,
    processId,
    level,
    parentId,
    pageTitle,
    user_id,
    currentParentId: routeParentId,
  } = useParams();
  const activeMode = version ? 'version' : mode; // 'edit', 'draft', 'published', 'version'
  const navigate = useNavigate();

  const location = useLocation();
  const LoginUser = useSelector((state) => state.user.user);
  const langMap = useLangMap();
  const t = useTranslation();
  const { goToProcess } = useProcessNavigation();
  const currentLevel = (() => {
    if (!level) return 0;
    if (String(level).startsWith('level')) {
      const match = String(level).match(/^level(\d+)/);
      return match ? parseInt(match[1], 10) : 0;
    }
    const parsed = parseInt(level, 10);
    return isNaN(parsed) ? 0 : parsed;
  })();
  const currentParentId =
    parentId ||
    (routeParentId && routeParentId !== 'null' && routeParentId !== 'undefined'
      ? routeParentId
      : null);

  useEffect(() => {
    setversionPopupPayload('');
  }, [processId, level, currentParentId, setversionPopupPayload]);
  const { addBreadcrumb, removeBreadcrumbsAfter, breadcrumbs, setBreadcrumbs } =
    useContext(BreadcrumbsContext);

  // Reconstruct breadcrumbs for direct links
  useReconstructBreadcrumbs(activeMode === 'published' ? 'publish' : 'draft');

  // Use custom hook for approval status
  const { pendingApproval, refetch: refetchApprovalStatus } = useApprovalStatus({
    processId,
    currentLevel,
    currentParentId,
    mode: activeMode,
  });

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  // Custom Hooks for Version Data and Approval Workflows
  const versionData = useMapLevelVersionData({
    processId,
    level,
    version,
    currentParentId,
    setNodes,
    setEdges,
    setSupportedLanguages,
    setprocessDefaultlanguage_id,
    setOriginalDefaultlanguge_id,
    Settitle,
  });

  const {
    contactInfo,
    revisionInfo,
    assignedUsers,
    versionStatus,
    versionDate,
    processImg,
    versionTitle,
    fetchVersionData,
    handleLanguageSwitch,
  } = versionData;

  const approvals = useMapLevelApprovals({
    processId,
    currentLevel,
    currentParentId,
    LoginUser,
    title,
    t,
    refetchApprovalStatus,
  });

  const {
    editScheduledModalOpen,
    setEditScheduledModalOpen,
    requestChangeModalOpen,
    setRequestChangeModalOpen,
    handleApproveProcess,
    handleCancelPublishing,
    handleReschedulePublishing,
    handleContentChangeRequest,
    handleCancelApproval,
  } = approvals;

  // Access control: Redirect to draft if request is pending and user tries to access edit mode
  const approvalStatus = pendingApproval?.approval?.status;

  useEffect(() => {
    if (activeMode === 'edit' && (approvalStatus === 0 || (user && user.role === 'User'))) {
      goToProcess({
        mode: 'draft',
        view: 'map',
        processId,
        level: currentLevel,
        parentId: currentParentId || undefined,
      });
    }
  }, [activeMode, approvalStatus, user, goToProcess, processId, currentLevel, currentParentId]);

  // Move Node State
  const [isLoading, setIsLoading] = useState(false);
  const [showMovePopup, setShowMovePopup] = useState(false);

  const handleMoveNodeClick = () => {
    setShowPopup(false);
    setShowMovePopup(true);
  };

  const currentLangCode = langMap[processDefaultlanguage_id] || 'de';

  const { responseData: revisionresponse, refetch } = useFetchVersions({
    processId,
    currentLevel,
    currentParentId,
    LoginUser,
    status: 'draft',
  });

  const latestPublishedVersion = useMemo(() => {
    if (!revisionresponse || !revisionresponse.versions || revisionresponse.versions.length === 0) {
      return '0.x.x';
    }
    const pubVersion = revisionresponse.versions.find(
      (v) => v.change_type && v.change_type !== 'Draft'
    );
    return pubVersion ? pubVersion.version : '0.x.x';
  }, [revisionresponse]);

  const currentVersion = useMemo(() => {
    if (activeMode === 'version') {
      return versionTitle || version;
    }
    if (activeMode === 'published') {
      return latestPublishedVersion !== '0.x.x' ? latestPublishedVersion : '1.0.000';
    }
    if (revisionresponse && revisionresponse.versions && revisionresponse.versions.length > 0) {
      return revisionresponse.versions[0].version;
    }
    return '0.0.001';
  }, [activeMode, versionTitle, version, latestPublishedVersion, revisionresponse]);

  const levelParam =
    level && level.startsWith('level') ? level : getLevelKey(currentLevel, currentParentId);
  const energyMeter = useEnergyMeter(
    processId,
    currentVersion,
    currentVersion,
    levelParam,
    activeMode === 'version'
  );

  const isEnergyMeterAllowed =
    activeMode === 'published' || (activeMode === 'version' && versionStatus === 'Published');

  const memoizedNodeTypes = useMemo(() => {
    const isEdit = activeMode === 'edit';
    return {
      progressArrow: (props) => (
        <ArrowBoxNode {...props} editable={isEdit} langCode={currentLangCode} />
      ),
      pentagon: (props) => <PentagonNode {...props} editable={isEdit} langCode={currentLangCode} />,
      StickyNote: (props) => <StickyNote {...props} editable={isEdit} />,
    };
  }, [activeMode, currentLangCode]);

  const memoizedEdgeTypes = useMemo(
    () => ({
      smoothstep: SmoothStepEdge,
      bezier: BezierEdge,
      straight: StraightEdge,
    }),
    []
  );

  const processLangRef = useRef(processDefaultlanguage_id);
  const langMapRef = useRef(langMap);

  useEffect(() => {
    processLangRef.current = processDefaultlanguage_id;
    langMapRef.current = langMap;
  }, [processDefaultlanguage_id, langMap]);

  const { handleLabelChange } = useLabelChange(
    setNodes,
    setHasUnsavedChanges,
    processLangRef,
    langMapRef
  );

  const { fetchNodes } = useFetchNodes({
    getLevelKey,
    currentLevel,
    currentParentId,
    LoginUser,
    id: processId,
    setNodes,
    setEdges,
    setUser,
    setters: {
      setgetPublishedDate,
      setDraftedDate,
      Settitle,
      SetTitleTranslation,
      setprocess_img,
      setSupportedLanguages,
      setprocessDefaultlanguage_id,
      setOriginalDefaultlanguge_id,
      SetParentPageGroupId,
    },
    mode: activeMode === 'published' ? 'publish' : activeMode === 'draft' ? 'draft' : 'edit',
    handleLabelChange,
  });

  const editHandlers = useMapLevelHandlers({
    state,
    nodes,
    setNodes,
    edges,
    setEdges,
    currentLevel,
    currentParentId,
    processId,
    LoginUser,
    fetchNodes,
    handleLabelChange,
    goToProcess,
    addBreadcrumb,
    langMap,
    t,
  });

  const viewHandlers = useMapLevelViewHandlers({
    state,
    nodes,
    currentLevel,
    currentParentId,
    processId,
    LoginUser,
    fetchNodes,
    goToProcess,
    addBreadcrumb,
    setBreadcrumbs,
    breadcrumbs,
    viewMode: activeMode === 'published' ? 'publish' : 'draft',
    energyMeter: isEnergyMeterAllowed ? energyMeter : undefined,
  });

  const handlers = activeMode === 'edit' ? editHandlers : viewHandlers;

  const handleMoveConfirm = async (target) => {
    try {
      setIsLoading(true);
      await moveNode({
        node_id: selectedNode,
        target_process_id: target.processId,
        target_level: target.levelKey,
        target_parent_id: null,
        position: { x: 0, y: 0 },
      });

      // Remove the moved node and its connected edges from canvas state immediately
      setNodes((nds) => nds.filter((n) => n.id !== selectedNode));
      setEdges((eds) => eds.filter((e) => e.source !== selectedNode && e.target !== selectedNode));
      setSelectedNode(null);
      setHasUnsavedChanges(false);

      // Clear cache for current process and target process
      handlers.invalidateCache(processId);
      if (target.processId) {
        handlers.invalidateCache(target.processId);
      }

      setShowMovePopup(false);

      CustomAlert.success(
        t('success') || 'Success',
        t('node_moved_successfully') || 'Node moved successfully'
      );

      // Refetch to update UI with fresh data from backend
      const savedLang =
        localStorage.getItem('selectedLanguageId') ||
        sessionStorage.getItem(`process_lang_id_${processId}`);
      await fetchNodes(savedLang ? parseInt(savedLang) : processDefaultlanguage_id, true);
    } catch (error) {
      logger.error('Failed to move node', error);
      CustomAlert.error(t('error') || 'Error', t('failed_to_move_node') || 'Failed to move node');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      if (activeMode === 'version') {
        await fetchVersionData();
      } else {
        await fetchNodes(state.processDefaultlanguage_id || undefined);
      }
      setIsLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLevel, activeMode, version]);

  useCheckFavorite({ id: processId, nodes, setIsFavorite });

  useEffect(() => {
    if (activeMode === 'version' || !title) return;
    const path = buildProcessPath({
      mode: activeMode === 'published' ? 'published' : activeMode === 'draft' ? 'draft' : 'edit',
      view: 'map',
      processId,
      level: currentLevel,
      parentId: currentLevel === 0 ? undefined : currentParentId,
    });
    const stateData = { id: processId, title, TitleTranslation };

    if (!breadcrumbs.some((b) => b.path === path)) {
      if (currentLevel >= 0 && isNavigating) {
        removeBreadcrumbsAfter(Math.max(1, currentLevel - 1));
      }
      addBreadcrumb(title, path, stateData);
    }
    setIsNavigating(false);
  }, [currentLevel, isNavigating, currentParentId, title, processId, breadcrumbs, activeMode]);

  useEffect(() => {
    const checkpublishfunction = async () => {
      if (activeMode === 'edit') {
        if (currentLevel !== 0 && currentParentId) {
          try {
            const response = await checkParentPublishRecords(currentParentId, processId);
            Setcheckpublish(response?.status === true);
          } catch (error) {
            logger.error('filter draft error', error);
          }
        } else if (currentLevel === 0) {
          Setcheckpublish(true);
        }
      } else if (activeMode === 'draft') {
        try {
          const data = await apiExports.checkPublishRecord(
            getLevelKey(currentLevel, currentParentId),
            processId
          );
          Setcheckpublish(data?.status);
        } catch (error) {
          logger.error('checkPublishRecord error', error);
        }
      }
    };
    checkpublishfunction();
  }, [currentParentId, currentLevel, processId, activeMode, Setcheckpublish]);

  useEffect(() => {
    if (activeMode !== 'edit') return;
    const handleKeyDown = (event) => {
      if (event.key === 'Delete' && selectedNode) handlers.deleteNode();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedNode, handlers.deleteNode, activeMode]);

  const handleGlobalContextMenu = (event) => {
    if (activeMode !== 'edit') return;
    if (event.target.closest('.react-flow__node')) return;
    event.preventDefault();
    setShowContextMenu(true);
    setContextMenuPosition({ x: event.clientX, y: event.clientY });
    setOriginalPosition({ x: event.clientX - 90, y: event.clientY - 90 });
    setShowPopup(false);
  };

  const handlePageClick = useCallback(() => {
    setShowPopup(false);
    setShowContextMenu(false);
  }, []);

  useEffect(() => {
    document.addEventListener('click', handlePageClick);
    return () => document.removeEventListener('click', handlePageClick);
  }, [handlePageClick]);

  const handleSavePublish = async () => {
    if (currentLevel !== 0) {
      try {
        const response = await checkParentPublishRecords(currentParentId, processId);
        if (response?.status === false) {
          CustomAlert.warning(t('warning'), t('publish_all_parent_models_first'));
          return false;
        }
      } catch (error) {
        logger.error('filter draft error', error);
      }
    }
    const latestData = await refetch();
    const contact = latestData?.contact_info;
    if (!contact || Object.values(contact).every((list) => !list || list.length === 0)) {
      CustomAlert.info(
        t('information'),
        t(
          'please_assign_process_owner_process_domain_owner_and_process_modeler_to_publish_the_model'
        )
      );
      return;
    }
    setShowPublishPopup(true);
  };

  const headerPage =
    activeMode === 'published'
      ? 'Published'
      : activeMode === 'draft'
        ? 'ViewDraftmodel'
        : activeMode === 'version'
          ? 'ViewProcessmapVersion'
          : 'Draft'; // Edit mode

  const headerTitle = activeMode === 'version' ? `${title} (Version: ${versionTitle})` : title;

  const headerOnSave =
    activeMode === 'edit'
      ? () => handlers.handleSaveNodes('draft')
      : activeMode === 'version'
        ? () => {}
        : handlers.navigateOnDraft;

  const headerOnPublish = activeMode === 'edit' ? () => handleSavePublish() : () => {};

  const headerAddNode =
    activeMode === 'edit' ? (type) => handlers.addNode(type, { x: 200, y: 200 }) : () => {};

  const headerHandleBackdata =
    activeMode === 'edit'
      ? handlers.handleBack
      : activeMode === 'version'
        ? () => navigate(-1)
        : () => {};

  const headerHandleSupportLanguageId =
    activeMode === 'version'
      ? handleLanguageSwitch
      : activeMode === 'edit'
        ? handlers.handleLanguageSwitch
        : handlers.handleSupportViewlangugeId;

  const watermarkText =
    activeMode === 'draft' || activeMode === 'edit'
      ? t('Draft')
      : activeMode === 'version'
        ? t('Archive')
        : undefined;

  return (
    <div dir="ltr">
      <Header
        title={headerTitle}
        onSave={headerOnSave}
        onPublish={headerOnPublish}
        addNode={headerAddNode}
        handleBackdata={headerHandleBackdata}
        iconNames={{}}
        currentLevel={currentLevel}
        getPublishedDate={
          activeMode === 'version' && versionStatus === 'Published' ? versionDate : getPublishedDate
        }
        getDraftedDate={
          activeMode === 'version' && versionStatus !== 'Published' ? versionDate : getDraftedDate
        }
        setIsNavigating={setIsNavigating}
        Page={headerPage}
        onExit={
          activeMode === 'edit'
            ? (type) =>
                type === 'exit'
                  ? handlers.handleBack().then(
                      (res) =>
                        res &&
                        handlers.goToProcess({
                          mode: 'draft',
                          view: 'map',
                          processId,
                          level: currentLevel,
                          parentId: currentLevel === 0 ? undefined : currentParentId,
                        })
                    )
                  : null
            : undefined
        }
        savefav={handlers.handleFav}
        isFavorite={isFavorite}
        Process_img={activeMode === 'version' ? processImg : process_img}
        Procesuser={
          activeMode === 'version'
            ? contactInfo
              ? { id: null, role: 'self', type: 'self' }
              : {}
            : user || {}
        }
        checkpublish={checkpublish}
        onShowVersion={() => setShowVersionPopup(true)}
        processId={processId}
        handleSupportViewlangugeId={headerHandleSupportLanguageId}
        supportedLanguages={supportedLanguages}
        selectedLanguage={processDefaultlanguage_id}
        OriginalDefaultlanguge_id={OriginalDefaultlanguge_id}
        energyMeterActive={isEnergyMeterAllowed && energyMeter.active}
        energyMeterHotspotCount={isEnergyMeterAllowed ? energyMeter.hotspotCount : undefined}
        onToggleEnergyMeter={isEnergyMeterAllowed ? energyMeter.toggleEnergyMeter : undefined}
        revisionresponse={revisionresponse}
        onApproveProcess={handleApproveProcess}
        onRequestChange={() => setRequestChangeModalOpen(true)}
        pendingApproval={pendingApproval}
        onEditScheduled={() => setEditScheduledModalOpen(true)}
        onCancelApproval={handleCancelApproval}
      />
      <ReactFlowProvider>
        <ProcessMapFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onNodeClick={
            activeMode !== 'edit' && activeMode !== 'version' ? handlers.handlenodeClick : undefined
          }
          nodeTypes={memoizedNodeTypes}
          edgeTypes={memoizedEdgeTypes}
          safeRemainingHeight={safeRemainingHeight}
          isLoading={isLoading}
          onNodeDragStop={activeMode === 'edit' ? handlers.handleNodeDragStop : undefined}
          onNodeContextMenu={activeMode === 'edit' ? handlers.handleNodeRightClick : undefined}
          snapToGrid={activeMode === 'edit'}
          snapGrid={activeMode === 'edit' ? [20, 20] : undefined}
          backgroundGap={20}
          onContextMenu={activeMode === 'edit' ? handleGlobalContextMenu : undefined}
          watermarkText={watermarkText}
          showBackground={activeMode === 'edit'}
          energyMeter={isEnergyMeterAllowed ? energyMeter : undefined}
          processId={processId}
          fitView={false}
          minZoom={1}
          maxZoom={1}
          defaultViewport={{ x: 0, y: 0, zoom: 1 }}
        >
          {activeMode === 'edit' && (
            <>
              <CustomContextMenu
                showContextMenu={showContextMenu}
                contextMenuPosition={contextMenuPosition}
                handleContextMenuOptionClick={(type) =>
                  handlers.addNode(type, { x: OriginalPosition.x, y: OriginalPosition.y })
                }
              />
              <Popup
                showPopup={showPopup}
                popupPosition={popupPosition}
                popupTitle={popupTitle}
                selectedNodeType={nodes.find((node) => node.id === selectedNode)?.type}
                switchNodeType={(type) => {
                  setNodes((nds) =>
                    nds.map((n) =>
                      n.id === selectedNode ? { ...n, type, data: { ...n.data, shape: type } } : n
                    )
                  );
                  setHasUnsavedChanges(true);
                  setShowPopup(false);
                }}
                handleCreateNewNode={handlers.handleCreateNewNode}
                deleteNode={handlers.deleteNode}
                translation={handlers.translation}
                duplicateNode={handlers.handleDuplicateNode}
                condition={checkRecord}
                moveNode={handleMoveNodeClick}
              />
            </>
          )}
        </ProcessMapFlow>
      </ReactFlowProvider>
      <MapLevelModals
        activeMode={activeMode}
        showTranslationPopup={showTranslationPopup}
        setShowTranslationPopup={setShowTranslationPopup}
        translationDefaults={translationDefaults}
        selectedNode={selectedNode}
        handlers={handlers}
        supportedLanguages={supportedLanguages}
        showPublishPopup={showPublishPopup}
        setShowPublishPopup={setShowPublishPopup}
        revisionresponse={revisionresponse}
        processDefaultlanguage_id={processDefaultlanguage_id}
        showEditorialPopup={showEditorialPopup}
        setShowEditorialPopup={setShowEditorialPopup}
        showContentPopup={showContentPopup}
        setShowContentPopup={setShowContentPopup}
        showMovePopup={showMovePopup}
        setShowMovePopup={setShowMovePopup}
        handleMoveConfirm={handleMoveConfirm}
        processId={processId}
        currentParentId={currentParentId}
        currentLevel={currentLevel}
        LoginUser={LoginUser}
        showVersionPopup={showVersionPopup}
        setShowVersionPopup={setShowVersionPopup}
        versionPopupPayload={versionPopupPayload}
        setversionPopupPayload={setversionPopupPayload}
        OriginalDefaultlanguge_id={OriginalDefaultlanguge_id}
        contactInfo={contactInfo}
        revisionInfo={revisionInfo}
        assignedUsers={assignedUsers}
        editScheduledModalOpen={editScheduledModalOpen}
        setEditScheduledModalOpen={setEditScheduledModalOpen}
        pendingApproval={pendingApproval}
        handleCancelPublishing={handleCancelPublishing}
        handleReschedulePublishing={handleReschedulePublishing}
        requestChangeModalOpen={requestChangeModalOpen}
        setRequestChangeModalOpen={setRequestChangeModalOpen}
        handleContentChangeRequest={handleContentChangeRequest}
        title={title}
      />
    </div>
  );
};

export default MapLevel;
